export default __webpack_public_path__ + "e2598f9d2d60f232b348fdd347931c2c.png";